import axios from "axios";
import { combinedUrls } from "../../../../../../URL/functions";
import { projectUrls } from "../../../../../../URL/ApplicationUrls";

export const getGsdbInfoRequest = async (newGsdb: string) => {
  if (!newGsdb) {
    throw new Error("The gsdb field is required");
  }

  const baseUrl = combinedUrls(
    projectUrls.base.apiUrl,
    "/GetDraggedPanelInfo"
  );

  let url;
  if (!newGsdb.includes(".")) {
    url = `${baseUrl}?gsdb=${newGsdb}`;
  } else {
    const splitGsdb = newGsdb.split(".");
    url = `${baseUrl}?gsdb=${splitGsdb[0]}&dockCode=${splitGsdb[1]}`;
  }

  const response = await axios.get(url);
  return response.data;
};
